import gql from 'graphql-tag';

import dokkioErrorFragment from './dokkioErrorFragment';

export const remoteItemPermissionCapabilitiesFragment = gql`
  fragment remoteItemPermissionCapabilitiesFragment on RemoteItemPermissionCapabilities {
    dokkioClass
    canDeletePermission
    canDeletePermissionReason {
      ...dokkioErrorFragment
    }
  }
  ${dokkioErrorFragment}
`;

export default remoteItemPermissionCapabilitiesFragment;
